import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Link de agencia (?ag=CODIGO): la compra web de esta visita genera comisión para esa agencia
const agencyRef = new URLSearchParams(window.location.search).get("ag");
if (agencyRef) sessionStorage.setItem("sg_ag", agencyRef.toUpperCase());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
